import { render } from "./MyProfileMenu.vue?vue&type=template&id=64cfc0d8&scoped=true"
import script from "./MyProfileMenu.vue?vue&type=script&lang=ts"
export * from "./MyProfileMenu.vue?vue&type=script&lang=ts"

import "./MyProfileMenu.vue?vue&type=style&index=0&id=64cfc0d8&lang=scss&scoped=true"
import "./MyProfileMenu.vue?vue&type=style&index=1&id=64cfc0d8&lang=scss"
script.render = render
script.__scopeId = "data-v-64cfc0d8"

export default script